module.exports = __webpack_public_path__ + "static/img/icon-volumeSmall.390e552e.png";